module.exports = __webpack_public_path__ + "src/client/assets/img/avatar-placeholder.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/avatar-placeholder.png
// module id = 480
// module chunks = 0